var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2187 0H0.781248C0.349731 0 0 0.349731 0 0.781248C0 1.21277 0.349731 1.5625 0.781248 1.5625H1.5625V3.89495C1.5625 4.64355 1.83166 5.36803 2.3204 5.9352L7.27721 11.6865C7.52165 11.97 7.65623 12.3323 7.65623 12.7066V17.0553C7.65623 17.3117 7.78197 17.5517 7.99284 17.6976L11.1178 19.8611C11.2509 19.9533 11.4064 20 11.5625 20C11.6865 20 11.811 19.9705 11.925 19.9107C12.1824 19.7758 12.3437 19.5092 12.3437 19.2187V12.7066C12.3437 12.3323 12.4783 11.97 12.7226 11.6865L13.804 10.432C14.0857 10.1051 14.049 9.6118 13.7222 9.33012C13.3955 9.04844 12.9022 9.08506 12.6204 9.41175L11.5391 10.6665C11.0504 11.2335 10.7812 11.958 10.7812 12.7066V17.7276L9.21873 16.6459V12.7066C9.21873 11.958 8.94957 11.2335 8.46083 10.6663L4.01488 5.5078H15.9852L15.0108 6.63832C14.7291 6.96517 14.7657 7.45848 15.0926 7.74016C15.2401 7.86742 15.4216 7.92967 15.6022 7.92967C15.8217 7.92967 16.0399 7.83781 16.1943 7.65852L17.6796 5.9352C18.1683 5.36803 18.4375 4.64355 18.4375 3.89495V1.5625H19.2187C19.6502 1.5625 20 1.21277 20 0.781248C20 0.349731 19.6502 0 19.2187 0V0ZM16.875 3.89495C16.875 3.91174 16.8744 3.92852 16.8739 3.9453H3.12621C3.1256 3.92852 3.12499 3.91174 3.12499 3.89495V1.5625H16.875V3.89495Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fc281922c4c5be41704309a801475068.svg";
export { ForwardRef as ReactComponent };